import queryString from 'query-string';
import type { IssueTypeResourceData } from '@jira/admin-pages__issue-types-common/src/IssueTypeScheme.types.tsx';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { ERROR_REPORTING_PACKAGE_NAME } from './errorReportingPackageName.constants.tsx';
import { toApiUrlTransformer, fromUrlTransformer } from './toSearchFilterQsTransformer.tsx';

export const getIssueTypes = async (qs: string): Promise<IssueTypeResourceData> => {
	const filter = fromUrlTransformer(queryString.parse(qs));
	const query = queryString.stringify(toApiUrlTransformer(filter));

	try {
		return await fetchJson(`/rest/internal/3/issuetype/search?${query}`);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'getIssueTypesRequest',
				packageName: ERROR_REPORTING_PACKAGE_NAME,
				teamName: 'morphinecake',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};
